module.exports = __webpack_public_path__ + "img/se.01887b79.svg";